export default ({ request }) => ({
  ordeDemandPackageListApi(data = {}) {
    return request({
      url: '/factory/order/demand/package/list',
      method: 'post',
      data
    })
  },
  ordeDemandPackageDetailApi(data = {}) {
    return request({
      url: '/factory/order/demand/package/detail',
      method: 'post',
      data
    })
  },
  ordeDemandPackageAddApi(data = {}) {
    return request({
      url: '/factory/order/demand/package/add',
      method: 'post',
      data
    })
  },
  ordeDemandPackageModifyApi(data = {}) {
    return request({
      url: '/factory/order/demand/package/modify',
      method: 'post',
      data
    })
  },
  ordeDemandPackageBatchDelApi(data = {}) {
    return request({
      url: '/factory/order/demand/package/batchDel',
      method: 'post',
      data
    })
  }
})
